import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GenericMaterialType, StorageUnitMaterialDto} from '@services';

@Component({
    selector: 'app-storage-unit-material',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="mb-3 fs-6 fw-bold">
            {{ material.type === GenericMaterialType.Material ? 'Material' : 'HALB' }}
        </div>
        <div class="row g-3 mx-3 mb-4">
            <div class="col-md-4">
                <div class="mb-2"><span class="fw-bold">Material:</span> {{ material.number }}</div>
                <div class="mb-2"><span class="fw-bold">Material Description:</span> {{ material.description }}</div>
                @if (material.type === GenericMaterialType.Material) {
                    <div class="mb-2"><span class="fw-bold">Sales Unit:</span> {{ material.salesUnit }}</div>
                }
            </div>
            <div class="col-md-4">
                <div class="mb-2"><span class="fw-bold">Material Storage Type:</span> {{ material.storageType }}</div>
                <div class="mb-2"><span class="fw-bold">Range Brand Description:</span> {{ material.rangeBrandDescription }}</div>
                <div class="mb-2"><span class="fw-bold">Material Group:</span> {{ material.materialGroup }}</div>
            </div>
            <div class="col-md-4">
                @if (material.type === GenericMaterialType.Material) {
                    <div class="mb-2"><span class="fw-bold">Category:</span> {{ material.category }}</div>
                    <div class="mb-2"><span class="fw-bold">Cases Per Pallet:</span> {{ material.casesPerPallet }}</div>
                }
                <div class="mb-2"><span class="fw-bold">Weight:</span> {{ material.weight | number:'1.3-3' }}</div>
                <div class="mb-2"><span class="fw-bold">Total quantity WMUoM:</span> {{ material.totalQuantityWmUoM }}</div>
            </div>
        </div>
    `
})
export class StorageUnitMaterialComponent {
    @Input({required: true}) material!: StorageUnitMaterialDto;
    protected readonly GenericMaterialType = GenericMaterialType;
}

